import {
  FastFieldProps,
  FormikContextType,
  GenericFieldHTMLAttributes,
  getIn
} from "formik";
import type { UserInput } from "@input-output-hk/essential-cardano-models";

export type AllFastFieldProps = FastFieldProps<UserInput> & {
  formik: FormikContextType<UserInput>;
} & GenericFieldHTMLAttributes & {
    readOnly?: boolean;
  };

export const shouldUpdateFastField = (
  next: AllFastFieldProps,
  curr: AllFastFieldProps
) => {
  const name = curr.name!;
  const res =
    next.name !== name ||
    next.required !== curr.required ||
    next.disabled !== curr.disabled ||
    next.readOnly !== curr.readOnly ||
    next.formik.isSubmitting !== curr.formik.isSubmitting ||
    Object.keys(next).length !== Object.keys(curr).length ||
    getIn(next.formik.values, name) !== getIn(curr.formik.values, name) ||
    getIn(next.formik.errors, name) !== getIn(curr.formik.errors, name) ||
    getIn(next.formik.touched, name) !== getIn(curr.formik.touched, name);
  return res;
};
